/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * All files containing `style` keyword are bundled together. The code used
 * gets applied both to the front of your site and to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './style.scss';

/**
 * Internal dependencies
 */
import Edit from './edit';
import metadata from './block.json';
/**
 * Registers a new block provided a unique name and an object defining its behavior.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
import { registerBlockType } from '@wordpress/blocks';

const helicopterIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" width="24" height="24">
        <path d="M1024,167.217L1024,856.783C1024,949.072 949.072,1024 856.783,1024L167.217,1024C74.928,1024 0,949.072 0,856.783L0,167.217C0,74.928 74.928,0 167.217,0L856.783,0C949.072,0 1024,74.928 1024,167.217Z" style={{ fill: '#D1CA0A' }}/>
		<g transform="matrix(0.84736,0,0,0.84736,238.952,295.033)">
			<path d="M128,32C128,14.3 142.3,0 160,0L544,0C561.7,0 576,14.3 576,32C576,49.7 561.7,64 544,64L384,64L384,128L416,128C504.4,128 576,199.6 576,288L576,352C576,369.7 561.7,384 544,384L320,384C299.9,384 280.9,374.5 268.8,358.4L197.4,263.2C193.9,258.5 189.1,254.9 183.7,252.7L47.2,198.1C37.7,194.3 30.5,186.1 28,176.1L5,83.9C2.4,73.8 10.1,64 20.5,64L48,64C58.1,64 67.6,68.7 73.6,76.8L112,128L320,128L320,64L160,64C142.3,64 128,49.7 128,32ZM384,320L512,320L512,288C512,235 469,192 416,192L384,192L384,320ZM630.6,425.4C643.1,437.9 643.1,458.2 630.6,470.7L626.7,474.6C602.7,498.6 570.1,512.1 536.2,512.1L256,512.1C238.3,512.1 224,497.8 224,480.1C224,462.4 238.3,448.1 256,448.1L536.2,448.1C553.2,448.1 569.5,441.4 581.5,429.4L585.4,425.5C597.9,413 618.2,413 630.7,425.5L630.6,425.4Z" style={{fill: '#000000'}}/>
		</g>
    </svg>
);

/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
registerBlockType( metadata.name, {
	icon: helicopterIcon,
	/**
	 * @see ./edit.js
	 */
	edit: Edit,


} );
